// extracted by mini-css-extract-plugin
module.exports = {"root":"History_root__3_C4o","title":"History_title__2bUXu","songs":"History_songs__2-jXd","loader":"History_loader__2Y4uS","loadercontent":"History_loadercontent__3o-gk"};